// extracted by mini-css-extract-plugin
module.exports = {"popconfirm":"CloseQuestionBtn_popconfirm__eMRpA"};